import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "root"
}
const _hoisted_2 = {
  key: 2,
  class: "root"
}
const _hoisted_3 = { class: "epinios-table" }
const _hoisted_4 = { class: "epinio-row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "epinio-row" }

import { ref, onMounted } from 'vue';
import { useStore } from 'vuex';

import Loading from '@shell/components/Loading.vue';
import ResourceTable from '@shell/components/ResourceTable.vue';
import AsyncButton from '@shell/components/AsyncButton.vue';

import { EPINIO_MGMT_STORE, EPINIO_TYPES } from '../types';
import { _MERGE } from '@shell/plugins/dashboard-store/actions';
import EpinioCluster, { EpinioInfoPath } from '../models/epiniomgmt/epinio.io.management.cluster';
import epinioAuth, { EpinioAuthTypes } from '../utils/auth';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const t = store.getters['i18n/t'];

let currentCluster: EpinioCluster | null = null;
let clusters: EpinioCluster[] = [];
let clustersSchema: any = null;

const loading = ref(true);
const error = ref<Error | null>(null)

onMounted(async () => {
  loading.value = true
  try {
    await store.dispatch(`${EPINIO_MGMT_STORE}/findAll`, { type: EPINIO_TYPES.CLUSTER }, { root: true })
    clusters = store.getters[`${EPINIO_MGMT_STORE}/all`](EPINIO_TYPES.CLUSTER)
    clustersSchema = store.getters[`${EPINIO_MGMT_STORE}/schemaFor`](EPINIO_TYPES.CLUSTER)

    clusters.forEach((c: EpinioCluster) => testCluster(c))
  } catch (err) {
    error.value = err as Error
  } finally {
    loading.value = false
  }
})

const canRediscover = () => {
  return !clusters.find((c: EpinioCluster) => c.state === 'updating');
}

const rediscover = async (buttonCb: (success: boolean) => void)  => {
  await store.dispatch(
    `${ EPINIO_MGMT_STORE }/findAll`,
    { type: EPINIO_TYPES.CLUSTER, opt: { force: true, load: _MERGE } },
  );
  clusters.forEach((c: EpinioCluster) => testCluster(c));
  buttonCb(true);
}

const login = async (c: EpinioCluster) =>{
  const isLoggedIn = await epinioAuth.isLoggedIn(c.createAuthConfig(EpinioAuthTypes.AGNOSTIC));

  if (isLoggedIn) {
    store.$router.push({
      name:   'epinio-c-cluster-dashboard',
      params: { cluster: c.id }
    });
  } else {
    currentCluster = c;
    store.dispatch('cluster/promptModal', {
      component: 'LoginDialog',
      componentProps: {
        cluster: currentCluster,
      },
    });
  }
}

const setClusterState = (
  cluster: EpinioCluster,
  state: string,
  metadataStateObj: {
    state: {
      transitioning: boolean,
      error: boolean,
      message: string
    }
  }) => {
  cluster['state'] = state;
  cluster['metadata'] = metadataStateObj;
}

const testCluster = (c: EpinioCluster) => {
  // Call '/ready' on each cluster. If there's a network error there's a good chance the user has to permit an invalid cert
  setClusterState(c, 'updating', {
    state: {
      transitioning: true,
      error:        false,
      message:       'Contacting...'
    }
  });

  store.dispatch(
    `epinio/request`,
    { opt: { url: EpinioInfoPath, redirectUnauthorized: false }, clusterId: c.id }
  )
  .then((res: any) => {
    c['version'] = res?.version;
    c['oidcEnabled'] = res?.oidc_enabled;
    setClusterState(
      c,
      'available',
      { state: { transitioning: false, error: false, message: "" } },
    );
  })
  .catch((e: Error) => {
    if (e.message === 'Network Error') {
      setClusterState(c, 'error', {
        state: {
          transitioning: false,
          error:   true,
          message: `Network Error. It may be that the certificate isn't trusted.
            Click on the URL above if you'd like to bypass checks and then refresh`
        }
      });
    } else {
      setClusterState(c, 'error', {
        state: {
          transitioning: false,
          error:   true,
          message: `Failed to check the ready state: ${ e }`
        }
      });
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_Link = _resolveComponent("Link")!

  return (loading.value)
    ? (_openBlock(), _createBlock(Loading, {
        key: 0,
        mode: "main"
      }))
    : (_unref(clusters).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, _toDisplayString(_unref(t)('epinio.instances.none.header')), 1),
          _cache[0] || (_cache[0] = _createTextVNode()),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('epinio.instances.none.description')), 1)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", null, _toDisplayString(_unref(t)('epinio.instances.header')), 1),
            _cache[3] || (_cache[3] = _createTextVNode()),
            _createVNode(ResourceTable, {
              rows: _unref(clusters),
              schema: _unref(clustersSchema),
              "table-actions": false
            }, {
              "header-left": _withCtx(() => [
                _createVNode(AsyncButton, {
                  mode: "refresh",
                  size: "sm",
                  disabled: !canRediscover,
                  style: {"display":"inline-flex"},
                  onClick: rediscover
                }, null, 8, ["disabled"])
              ]),
              "cell:name": _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_4, [
                  (row.state === 'available')
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        onClick: ($event: any) => (login(row))
                      }, _toDisplayString(row.name), 9, _hoisted_5))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row.name), 1)
                      ], 64))
                ])
              ]),
              "cell:api": _withCtx(({row}) => [
                _createElementVNode("div", _hoisted_6, [
                  (row.state !== 'available')
                    ? (_openBlock(), _createBlock(_component_Link, {
                        key: 0,
                        row: row,
                        value: { text: row.api, url: row.infoUrl }
                      }, null, 8, ["row", "value"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row.api), 1)
                      ], 64))
                ])
              ]),
              _: 1,
              __: [1,2]
            }, 8, ["rows", "schema"])
          ])
        ]))
}
}

})